import React from 'react'

const Home = () => {
  return (
    <div>Home</div>
  )
  //TODO: Add curated list of recent activity
}

export default Home